function IssuedStatus() {
  return (
    <div className="w-[84px] h-[22px] flex items-center justify-center rounded-[11px] bg-po_color2 font-OpenSansRegular font-[400] text-titleColor text-[10px]">
      ISSUED
    </div>
  );
}

export default IssuedStatus;
